import get from 'lodash/get';

import { useScreenState } from '@gogame/screens';

export function useGetScreenStateProp(path) {
  const state = useScreenState();
  return get(state, `temporary.${path}`, get(state, path));
}
